const returnErrorObject = (
  clientError,
  errorDetails,
  message,
  serverError,
) => ({
  clientError,
  errorDetails,
  message,
  serverError,
});

export const serverErrors = ({
  response,
  request,
  message,
  config,
  response: {
    data,
    data: { error = {} } = {},
    status,
  } = {},
} = {}) => {
  switch (true) {
    case response && data && status >= 400 && status !== 404 && status <= 499:
      return returnErrorObject(true, data, data.message, false);

    case response && status >= 500:
      return returnErrorObject(false, data, 'Internal Server Error', true);

    case response && status === 404:
      return returnErrorObject(true, data, 'Not found', false);

    case !response && request:
      return returnErrorObject(false, data, request, false);

    case !!message:
      return returnErrorObject(false, data, message, false);

    default:
      return returnErrorObject(false, data, config, false);
  }
};
